<template>
  <el-dialog
    v-if="dialogVisible"
    show-close
    :visible.sync="dialogVisible"
    width="500px"
    title="扫码添加"
    :close-on-click-modal="false"
    :before-close="() => closeDialogVisible()"
    destroy-on-close
    append-to-body
  >
    <el-form
      ref="form"
      :model="formData"
      label-width="120px"
      onsubmit="return false"
      :rules="rules"
      @keyup.enter.native="sampleBarcodeSave"
      style="margin-top: 30px;margin-bottom: 50px;"
    >
      <el-row>
        <el-col :span="20">
          <el-form-item label="样品条码" prop="sampleBarcode">
            <el-input
              v-model="formData.sampleBarcode"
              size="medium"
              clearable
              ref="mark"
              placeholder="请输入样品条码..."
              maxlength="20"
            >
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </el-dialog>
</template>
<script>
import validate from '@/libs/util.validate'
export default {
  props: {
    dialogVisible: { type: Boolean, default: false },
    billType: String,
  },
  watch: {
    dialogVisible: {
      handler(val) {
        if (val) {
          this.$nextTick(() => {
            // 自动获取焦点 element组件autofocus失效
            this.$refs.mark.focus()
            this.$refs.mark.$el.querySelector('input').focus()
          })
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      formData: {
        sampleBarcode: '',
        billType: '',
      },
      rules: {
        sampleBarcode: [
          {
            required: true,
            message: '请输入样品条码',
            trigger: 'change',
          },
        ],
      },
    }
  },
  methods: {
    async sampleBarcodeSave() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return
      this.$api
        .stockSampleLocationDetailByBarcodeApi({
          sampleBarcode: this.formData.sampleBarcode,
          billType: this.billType,
        })
        .then((res) => {
          if (res.body.data) {
            this.$emit('confirm', res.body.data)
          } else {
            this.$message.error('条码不存在')
          }
        })
        .catch(() => {
          this.formData.sampleBarcode = ''
        })
      this.formData.sampleBarcode = ''
    },
    closeDialogVisible() {
      this.$emit('update:dialogVisible', false)
      this.formData.sampleBarcode = ''
    },
  },
}
</script>
